import React from 'react';
import { Link } from 'react-router-dom';

function Header() {
  return (
    <header className="header">
      <div className="header-container">
        <div className="header-logo">
          <Link to="/">🌿 ROOTS</Link>
        </div>
        <nav className="header-nav">
          <a href="#catalog">Каталог</a>
        </nav>
      </div>
    </header>
  );
}

export default Header;
